import { render, staticRenderFns } from "./buyOrderSearchDetails.vue?vue&type=template&id=3ee8fa0b&scoped=true&"
import script from "./buyOrderSearchDetails.vue?vue&type=script&lang=js&"
export * from "./buyOrderSearchDetails.vue?vue&type=script&lang=js&"
import style0 from "./buyOrderSearchDetails.vue?vue&type=style&index=0&id=3ee8fa0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8fa0b",
  null
  
)

export default component.exports